import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsSatochip({ t, options, handleOptionChange, osSelected }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.seedsignerSatochip")}>
      <PathOption
        id="store-key-on-satochip"
        label={t("pathBuilder.checkboxes.storeKeyOnSatochip")}
        checked={options.storeKeyOnSatochip}
        onChange={() => handleOptionChange("storeKeyOnSatochip")}
        disabled={!osSelected}
      />
      <PathOption
        id="sign-transaction-with-satochip"
        label={t("pathBuilder.checkboxes.signTransactionWithSatochip")}
        checked={options.signTransactionWithSatochip}
        onChange={() => handleOptionChange("signTransactionWithSatochip")}
        disabled={!osSelected}
      />
      <PathOption
        id="import-key-from-satochip"
        label={t("pathBuilder.checkboxes.importKeyFromSatochip")}
        checked={options.importKeyFromSatochip}
        onChange={() => handleOptionChange("importKeyFromSatochip")}
        disabled={!osSelected}
      />
      <PathOption
        id="backup-seed-to-satochip"
        label={t("pathBuilder.checkboxes.backupSeedToSatochip")}
        checked={options.backupSeedToSatochip}
        onChange={() => handleOptionChange("backupSeedToSatochip")}
        disabled={!osSelected}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsSatochip;
